var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[_vm.css(), ( _obj = {}, _obj[_vm.css('', 'active')] = _vm.isChecked, _obj )],attrs:{"for":_vm._uid,"data-test":"button"}},[_c('input',{class:_vm.css('input'),attrs:{"id":_vm._uid,"type":"radio","data-test":"input"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":function($event){return _vm.$emit('change', $event.target.value)}}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }